import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=64812604"
import script from "./roleList.vue?vue&type=script&lang=js"
export * from "./roleList.vue?vue&type=script&lang=js"
import style0 from "./roleList.vue?vue&type=style&index=0&id=64812604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports